import { render, staticRenderFns } from "./ProductCommunications.vue?vue&type=template&id=68fbeedc"
import script from "./ProductCommunications.vue?vue&type=script&lang=js"
export * from "./ProductCommunications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports